import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Admin } from '../../../services/admin';
import { Seller } from '../../../services/seller';
import { Master } from '../../../services/master';
import { FormControl } from '@angular/forms';
import { Auth } from '../../../services/auth';
import { Location } from '@angular/common';
import { MyDrive } from '../../../account/my-drive/my-drive';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../../services/user';
import { NavStateService } from '../../../services/nav-state.service';
import { SuccessDialog } from '../success-dialog/success-dialog';
import { ViewUploadedFile } from '../view-uploaded-file/view-uploaded-file';
@Component({
  selector: 'app-shipment-tracking',
  standalone: false,
  templateUrl: './shipment-tracking.html',
  styleUrl: './shipment-tracking.less'
})
export class ShipmentTracking implements OnInit{
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private adminService = inject(Admin);
  private sellerService = inject(Seller);
  private masterService = inject(Master);
  private authService = inject(Auth);
  private location = inject(Location); 
  private matDialog = inject(MatDialog);
  private userService = inject(User);
  orderDetails:any;
  loading:boolean = false;
  articleImage:any;
  orderStatusList:any=[];
  orderStatusListBuyer:any=[];
  orderStatusListSeller:any=[];
  orderUpdate= new FormControl('');
  user:any;
  uploadedFileId:any;
  selectedFiles:any;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  private navState = inject(NavStateService);
  selectedField:any;
  showDocTypeError: boolean = false;
  uploadDocuments: any[] = [
    { label: "Select", value: "" },
    { label: "Commercial Invoice", value: "commercialInvoice" },
    { label: "Packing List", value: "packingList" },
    { label: "Bill of Lading", value: "billOfLading" },
    { label: "Certificate of Origin", value: "certificateOfOrigin" },
    { label: "Quality Certificate", value: "qualityCertificate" },
    { label: "Other", value: "other" }
  ];
  documents: any[] = [];
  orderStatus = [
    {
      label: 'New',
      date: '27 Jul 2025',
      icon: 'bi bi-shop',        
      completed: false,
      last: false
    },
    {
      label: 'Approved',
      date: '27 Jul 2025',
      icon: 'bi bi-bag-fill',
      completed: false,
      last: false
    },
    {
      label: 'Allocated',
      date: '28 Jul 2025',
      icon: 'bi bi-box-seam',
      completed: false,
      last: false
    },
    {
      label: 'Shipped',
      date: '28 Jul 2025',
      icon: 'bi bi-truck',
      completed: false,
      last: false
    },
    {
      label: 'Received',
      date: '',                  
      icon: 'bi bi-house-door',
      completed: false,
      last: true
    }
  ];
  
  constructor( 
    
  ){
      // const data = this.route.snapshot;
      // const queryParams = data.queryParams['order'];
      // this.orderDetails = JSON.parse(queryParams);
      // console.log(this.orderDetails);
      this.authService.user.subscribe((x:any)=>this.user =x);
  }

  ngOnInit(): void {
   const data= window.history.state.order;
   this.orderDetails= JSON.parse(data);
      this.navState.setCurrentTitle('Order Details for '+this.orderDetails.displayId);
     this.navState.setShowBackButton(true);
    console.log(this.orderDetails);
    this.updateAuditTrailStatus(this.orderDetails.auditTrails);
     this.getOrderStatus();
     this.orderUpdate.patchValue(this.orderDetails.status);
     this.getMediaFile();
     this.getMediaFiles();
  }

  getMediaFile(){
    this.adminService.getMediaById(this.orderDetails?.article.articleImage).subscribe({
      next: (data: Blob) => {
        const reader = new FileReader();
        reader.onload = (e: any) => this.articleImage = e.target.result;
        reader.readAsDataURL(data);
      },
      error: (err) => {
        console.error(err);
      }
    });
    
  }

  updateStatus(step:any){
      console.log("Status updated");
      const formData ={
        comment:step.label,
        sourceType:step.label
      }
    this.sellerService.updateShipmentStatus(formData,this.orderDetails.id)
    .subscribe({
      next:(data:any)=>{
        console.log(data);
        this.orderStatus.forEach((status)=>{
          if(status.label=== step.label){
            status.completed = true;
            this.router.navigate(['/my-shipments']);
          }
        });
      },error:(error:any)=>{
        console.log(error.error.error);
      }
    })
     
    
  }

  updateOrderStatus(){
    const formData  ={
        ...this.orderDetails,
        status : this.orderUpdate.value,
    }
   this.sellerService.updateOrder(formData,this.orderDetails.id)
   .subscribe({
    next:(data:any)=>{
      console.log(data);
      this.getOrderDetailsById(this.orderDetails.id);
      this.router.navigate(['/my-shipments']);
    },error:(error:any)=>{
      console.log(error);
    }
   })
  }

  isPrivileges(privileges:any){
    const check = this.user?.privileges?.filter((x:any) => privileges.includes(x));
    if(check !=undefined && check.length >0){
      return true;
    }else{
      return false;
    }
  }

  getOrderDetailsById(orderId:any){
    this.loading = true;
    this.masterService.getOrderDetailsById(orderId)
    .subscribe({
      next:(data:any)=>{

        console.log(data);
        this.orderDetails = data;
        this.loading = false;
      },error:(error:any)=>{
        console.log(error);
      }
    })
  }


  getOrderStatus(){
    this.masterService.getOrderStatusList()
    .pipe()
    .subscribe({
      next:(data:any)=>{
        console.log(data);
        this.orderStatusList = data;
        // this.orderStatusListBuyer = list.filter((x:any)=>x.allowBuyer == true);
        // this.orderStatusListSeller = list.filter((x:any)=>x.allowSeller ==  true);
        console.log(this.orderStatusListBuyer);
        console.log(this.orderStatusListSeller);
      },error:(error:any)=>{
        console.log(error);
      }
    })
  }

  updateAuditTrailStatus(auditTrail:any){
    const latestStatus = auditTrail[0]?.newStatus;
    console.log(latestStatus);
    let statusReached = false;
    this.orderStatus.forEach((status)=>{
      if(status.label === latestStatus){
        status.completed = true;
        statusReached = true;
      } else if(!statusReached){
        status.completed = true;
      }else{
        status.completed = false;
      }
    });
}

uploadFile(step:any){

}

 statusClass(status: string) {
    if (!status) return 'status-default';
    const s = (status || '').toLowerCase();
    if(s === 'accept') return 'status-green';
    if(s === 'rejected') return 'status-red';
    if(s === 'payment completed') return 'status-blue';
    if(s === 'negotiate') return 'status-purple';
    if(s === 'packaging') return 'status-purple-2';
    if(s === 'reached destination') return 'status-blue-2';
    if(s === 'ready to ship') return 'status-beige';
    if(s === 'shipped') return 'status-green-2';
    if(s=== 'new') return 'status-blue-1';
    if(s === 'allocated') return 'status-beige-2';
     if(s === 'approved') return 'status-green-3';
     if(s === 'dispute shipment') return 'status-puple-3';
     if(s === 'dispute resolved') return 'status-beige-1';
     if(s === 'completed') return 'status-green-4';
     if(s === 'received') return 'status-green-5';
    return 'status-default';
  }

getMediaFiles() {
  this.userService.getMediaFiles('ORDER', this.orderDetails.id)
    .subscribe({
      next: (data: any) => {
        console.log(data);
        this.documents = data;
      }
    })
}

seletedFileName(event: any) {
  this.selectedField = event.value;
  this.showDocTypeError = false;
  this.getMediaFiles();
}

onDragOver(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.add('drag-over');
}

onDragLeave(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.remove('drag-over');
}

onDrop(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.remove('drag-over');

  if (!this.selectedField || this.selectedField === '') {
    this.showDocTypeError = true;
    return;
  }

  const files = event.dataTransfer.files;
  if (files && files.length > 0) {
    this.uploadMedia(files, this.selectedField);
  }
}

triggerFileInput(fieldName: string): void {
  this.selectedField = fieldName;
  this.fileInput.nativeElement.click();
}

handleFileSelect(event:any) {
  this.selectedFiles = event.target.files;
  if(this.selectedFiles && this.selectedFiles.length > 0){
    this.uploadMedia(this.selectedFiles,this.selectedFiles[0].name);
  }
}

uploadMedia(media:any,docType:any){ 
  if (!media || media.length === 0) return;
  const currentFile = media.item(0);
  if (!currentFile) return;

  const maxSize = 10 * 1024 * 1024;
  if (currentFile.size > maxSize) {
    this.messageDialog('File Too Large', 'The selected file exceeds the maximum allowed size of 10MB.', 'error');
    return;
  }

  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain'
  ];
  const isImage = currentFile.type.startsWith('image/');
  const isAllowedType = allowedTypes.includes(currentFile.type) || isImage;
  if (!isAllowedType) {
    this.messageDialog('Invalid File Type', 'Only images, PDFs, or Word documents (.doc, .docx) are allowed.', 'error');
    return;
  }

  this.loading = true;
  const mediaData = new FormData();
  mediaData.append("file",currentFile);
  mediaData.append("entityType",'ORDER');
  mediaData.append("entityId",this.orderDetails.id);
  mediaData.append("docType",docType);
  this.adminService.uploadProfilePic(mediaData).pipe()
    .subscribe({
      next: (data: any) => {
        this.uploadedFileId = data.id;
        this.loading = false;
        this.getMediaFiles();
      },
      error: (error) => {
        this.loading = false;
        console.log(error);
      },
    });

  this.selectedFiles = undefined;
}

viewMediaFile(row: any) {
  let viewFileComponent = this.matDialog.open(ViewUploadedFile, {
    disableClose: true,
    height: '800px',
    width: '800px',
    data: row
  });
  viewFileComponent.afterClosed().subscribe(result => {
  });
}

deleteMedia(id: any) {
  this.loading = true;
  this.userService.deleteMediaById(id).subscribe({
    next: (data: any) => {
      this.loading = false;
      this.getMediaFiles();
    },
    error: (error: any) => {
      this.loading = false;
      console.log(error);
    }
  });
}

messageDialog(text: any, status: any, type: string) {
  const dialog = this.matDialog.open(SuccessDialog, {
    disableClose: true,
    width: "500px",
    data: {
      title: text,
      subtitle: status,
      icon: type
    },
  });
  dialog.afterClosed().subscribe((result) => { });
}

close(){
  this.location.back();

}

viewOrderDocuments(){
  const myDriveRef = this.matDialog.open(MyDrive,{
    height:'600px',
    width:'700px',
    disableClose:true,
    panelClass: 'custom-dialog-container',
    data:{
      entityName:'ORDER',
      entityId:this.orderDetails.id,
    }
  });
  myDriveRef.afterClosed().subscribe(result=>{
    // console.log(result)
  })
}
}
